import React, { useEffect, useState } from 'react';
import 'date-fns';
import {
  Box,
  CardContent,
  CardHeader,
  Container,
  Card,
  Divider,
  Grid,
  TextField,
  MenuItem,
  createMuiTheme,
  BottomNavigationAction,
  BottomNavigation,
  Snackbar,
  Breadcrumbs,
  Link,
  Typography, Backdrop, CircularProgress
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import AddBoxIcon from '@material-ui/icons/AddBox';
import PhoneInput from 'react-phone-input-2';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { getUser } from 'src/utils/Common';
import SaveIcon from '@material-ui/icons/Save';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import axios from 'src/utils/axios';
import trLocale from "date-fns/locale/tr";
import ReactFlagsSelect from 'react-flags-select';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/EmployeeExcelExport';
import validator from 'validator';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 275,
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

  cardscontent: {
    minHeight: 550
  },
  cardscontentX: {
    minHeight: 100
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  cardsMax: {
    // maxHeight: 230,
    minHeight: 230
  },
  cardsContentMax: {
    // maxHeight: 180,
    minHeight: 180
  },
  cards: {
    minHeight: 350
    // maxHeight: 500,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale,
};

function TechnicianManagement(readonly) {
  const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));
  const classes = useStyles();
  const { t } = useTranslation('Technician_Management');
  const [newtel, setNewTel] = useState();
  const [paramPhonesType, setParamPhonesType] = useState();
  const [countryCode, setCountryCode] = useState();
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [PhoneTypes, setPhoneTypes] = useState([]);
  const [AddressTypes, setAddressTypes] = useState([]);
  const locale = localStorage.getItem('i18nextLng');
  const [AddressIndex, setAddressIndex] = useState('');
  const [emailError, setEmailError] = useState('');
  const [Loading, setLoading] = useState(false);
  const [ValidControlColor, setValidControlColor] = useState(false);
  const SessionUser = getUser();
  const [serviceShopId, setServiceShopId] = useState();
  const [selectedServiceShop, setSelectedServiceShop] = useState(null);
  const [employeeId, setEmployeeId] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selected, setSelected] = useState(SessionUser.TenantCode.toUpperCase());
  //UserType
  const [siriusUserTypeData, setSiriusUserTypeData] = useState([]);
  //UserType
  const [employeeRoleData, setEmployeeRoleData] = useState([]);
  //Export
  const [employeeExcelExportData, setEmployeeExcelExportData] = useState([]);
  //Required field
  const [Required, setRequired] = React.useState(false);

  const [serviceShopData, setServiceShopData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [DisabledControl, setDisabledControl] = useState(false);

  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });

  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      setDisabledControl(true);
      setFormdata({
        ...formData,
        ServiceShopId: SessionUser.ServiceShopId
      })
    }
  }, [SessionUser.Role]);

  const DeletePhoneItem = (event, Phone) => {
    const selectedChangePhones = [...formData.Phones];
    var filteredIndex = selectedChangePhones.findIndex(x => x.Phone === Phone);
    selectedChangePhones.splice(filteredIndex, 1);
    setFormdata({ ...formData, Phones: selectedChangePhones });
  };

  const GetEmployees = (employeeId) => {
    setLoading(true);
    axios
      .get('/GetEmployees/' + employeeId)
      .then(response => {
        setFormdata(response.data[0]);
        if (!response.data[0].Phones) {
          setFormdata({ ...response.data[0], Phones: [] });
          setLoading(false);
        }
      })
      .catch(error => { });
    setLoading(false);
  }
  const GetAddressTypes = () => {
    setLoading(true);
    axios
      .get(`/GetAddressTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setAddressTypes(response.data);
          setAddressIndex(1);
          setLoading(false);
        }
      })
      .catch(error => { });
    setLoading(false);
  };
  const GetPhoneTypes = () => {
    axios
      .get(`/GetPhoneTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setPhoneTypes(response.data);
          //setParamPhonesType(1);
          //setRequired(true);
        }
      })
      .catch(error => { });
  };
  const GetSiriusUserType = () => {
    axios
      .get(`/GetSiriusUserType`)
      .then(response => {
        if (response.data.length > 0) {
          setSiriusUserTypeData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetEmployeeRole = () => {
    axios
      .get(`/GetEmployeeRole`)
      .then(response => {
        if (response.data.length > 0) {
          setEmployeeRoleData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetServiceEmployeesAdressPhones = () => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      axios
        .get('/GetServiceEmployeesAdressPhones/' + SessionUser.ServiceShopId)
        .then(response => {
          setEmployeeExcelExportData(response.data)
        })
        .catch(error => { });
    }
  }
  async function changeEmployees(employee) {
    setLoading(true);
    setSelectedServiceShop(employee);
    setServiceShopId(employee.ServiceShopId);
    setFormdata({ ...formData, ServiceShopId: employee.ServiceShopId })
    axios
      .get('/GetEmployeeRequest/' + employee.ServiceShopId)
      .then(response => {
        setEmployeeData(response.data);
      })
      .catch(error => { });
    setLoading(false);
    axios
      .get('/GetServiceEmployeesAdressPhones/' + employee.ServiceShopId)
      .then(response => {
        setEmployeeExcelExportData(response.data)
        setLoading(false);
      })
      .catch(error => { });
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const GetServiceShopRequest = () => {
    setLoading(true);
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      axios
        .get('/GetServiceShopRequest/')
        .then(response => {
          setServiceShopData(response.data)
          const filteredItem = response.data.filter(x => x.ServiceShopId === SessionUser.ServiceShopId);
          setSelectedServiceShop(filteredItem[0]);
          setLoading(false);
        })
        .catch(error => { });
      setLoading(false);
    } else {
      axios
        .get('/GetServiceShopRequest/')
        .then(response => {
          setServiceShopData(response.data)
          setLoading(false);
        })
        .catch(error => { });
      setLoading(false);

    }
  }

  async function changeServiceShopData(employee) {
    setFormdata({ ...formData, ServiceShopId: employee.ServiceShopId })
  }

  const GetEmployeeRequest = () => {
    setLoading(true)
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      axios
        .get('/GetEmployeeRequest/' + SessionUser.ServiceShopId)
        .then(response => {
          setEmployeeData(response.data);
          setLoading(false);
        })
        .catch(error => { });
    }
  }


  useEffect(() => {
    GetAddressTypes();
    GetPhoneTypes();
    GetSiriusUserType();
    GetServiceShopRequest();
    GetEmployeeRole();
    GetServiceEmployeesAdressPhones();
    GetEmployeeRequest();
  }, [locale]);

  const DefaultEmployeeValue = {
    "ServiceShopId": 0,
    "ConsumerId": "",
    "Title": "",
    "FirstName": "",
    "MiddleName": "",
    "LastName": "",
    "CreateDate": "",
    "UpdateDate":moment(),
    "Active": true,
    "Email": "",
    "ConsumerTypeId": "",
    "TaxId": "",
    "TaxOffice": "",
    "ExceptId": "",
    "TenantId": "",
    "IdNr": "",
    "CreateEmployeeId": "",
    "UpdateEmployeeId": "",
    "InsurancePlanNumber": "",
    "ReferralNumber": "",
    "SourceServiceShopId": "",
    "Dsc": "",
    "UserName": "",
    "Birthday": moment(),
    "BloodType": "",
    "DrivingLicense": 0,
    "Education": 0,
    "EndDate": moment(),
    "StartDate": moment(),
    "Gender": 0,
    "MaritalStatus": 0,
    "EmployeeId": 0,
    "Military": 0,
    "ReasonLeaving": 0,
    "ConsumerAddressTypeId": 0,
    "FieldText": "",
    "Phones": [],
    "Address": "",
    "Apartment": "",
    "City": "",
    "Country": "",
    "State": "",
    "Region": "",
    "District": "",
    "Neighborhood": "",
    "Street": "",
    "DoorNr": "",
    "PostCode": "",
    "RegistrationNo": '',
    "UserType": '',
    "RoleId": 1,
    "CreateEmployee":"",
    "UpdateEmployee":"",
    "UpdateEmployeeId": SessionUser.TechnicianId
  };
  const [formData, setFormdata] = useState(DefaultEmployeeValue);

  const handleBirthdayChange = (e) => {
    setFormdata({ ...formData, Birthday: e });
  }
  const handleUpdateDateChange = (e) => {
    setFormdata({ ...formData, UpdateDate: e });
  }

  const handleStartDateChange = (e) => {
    setFormdata({ ...formData, StartDate: e });
  }

  const handleEndDateChange = (e) => {
    setFormdata({ ...formData, EndDate: e });
  }

  const saveEmployee = () => {
    let uyari = false;

    // if (SessionUser.Role > 2) {
    //   setresponseMessage({
    //     ErrorCode: 10,
    //     ErrorDescription: t('lblRoleControl')
    //   });
    //   setUyariTip('error');
    //   setUyari(true);
    //   return;
    // }


    if (formData.Phones.length === 0) {
      if ((newtel === '' ||
        newtel === undefined ||
        paramPhonesType === 0 ||
        paramPhonesType === undefined ||
        paramPhonesType === '' || newtel.length === countryCode.length)) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        uyari = true;
        setRequired(true);
      }
      else {
        handleOnAdd();
      }
    }
    if (!formData.FirstName || !formData.LastName || !formData.UserType) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      uyari = true;
      setRequired(true);
    }
    if (emailError || uyari) {
      setUyari(true);
      return;
    }
    if (uyari) {
      setUyari(true);
      return;
    }
    confirmAlert({
      message: t('lblConfirm'),
      buttons: [
        {
          label: t('lblYes'),
          onClick: () => SaveEmployeeYes(formData)
        },
        {
          label: t('lblNo'),
          onClick: () => {
            return;
          }
        }
      ]
    });
  }
  const SaveEmployeeYes = (formData) => {
    const dataBody = { ...formData };
    if (parseInt(dataBody.RoleId) > 2) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblRoleControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    var UserTypeServiceShopControl = dataBody.UserType.filter(x => x.ServiceShopControl === 0);

    if (UserTypeServiceShopControl?.length > 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblRoleControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    if (dataBody.ServiceShopId === 0) {
      dataBody.ServiceShopId = SessionUser.ServiceShopId;
    }
    setLoading(true);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetEmployeeData', dataBody, dataConfig)
      .then(response => {
        setLoading(false);
        var ResponseData = response.data[0];
        if (ResponseData.ErrorCode && ResponseData.ErrorCode === '1000') {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t(ResponseData.ErrorDescription)
          });
          setUyariTip('error');
          setUyari(true);
        } else {
          console.log(ResponseData);
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
          GetEmployees(ResponseData.EmployeeId);
          axios
            .get('/GetEmployeeRequest/' + ResponseData.ServiceShopId, ResponseData.EmployeeId)
            .then(response => {
              setEmployeeData(response.data);
            })
            .catch(error => { });
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  }
  const validateEmail = event => {
    var email = event.target.value;
    if (validator.isEmail(email) || email === '') {
      setEmailError('');
      setValidControlColor(false);
    } else {
      setEmailError('Enter valid Email!');
      setValidControlColor(true);
    }
    setFormdata({ ...formData, Email: event.target.value });
  };
  function handleOnAdd() {
    if (!newtel || !paramPhonesType || newtel.length === countryCode.length) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const PhonesData = [...formData.Phones];
    const PhoneType = PhoneTypes.filter((item) => item.Id === paramPhonesType);
    const Data = {
      PhoneId: 0,
      Phone: newtel,
      PhoneTypeId: paramPhonesType,
      Dsc: PhoneType[0].Dsc
    };
    PhonesData.push(Data);
    setFormdata({ ...formData, Phones: PhonesData });
    setNewTel(countryCode);
  }
  const SetCountry = (code) => {
    setSelected(code);
    setFormdata({ ...formData, Country: code });
  }
  function handleOnChange(value, country) {
    SetCountry(country.countryCode.toUpperCase())
    setNewTel(value);
    setCountryCode(country.dialCode);
  }

  const GetUserPassword = () => {
    axios
      .get('/GetUserPassword/' + formData.RegistrationNo)
      .then(response => {
        setresponseMessage({
          ErrorCode: 0,
          ErrorDescription: response.data
        });
        setUyariTip('success');
        setUyari(true);
      })
      .catch(error => { });
  }


  return (
    <Container maxWidth="xl" spacing={1}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Breadcrumbs >
        <Link color="inherit">Sirius</Link>
        <Typography color="textPrimary">{t('Technician Management')}</Typography>
      </Breadcrumbs>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Card>
        <Divider />
        <CardContent>
          <BottomNavigation>
            <BottomNavigationAction onClick={() => { saveEmployee() }} showLabel={true} label={t('lblSave')} icon={<SaveIcon />} />
            <BottomNavigationAction onClick={() => {
              setFormdata(DefaultEmployeeValue);
              setEmployeeId(0);
              setSelectedEmployee('');
              setNewTel(countryCode);
            }} showLabel={true} label={t('lblNewEmployee')} icon={<PersonAddIcon />} />
            <ExcelExport JsonData={employeeExcelExportData} title={t('Export')} />
          </BottomNavigation>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        autoSelect
                        disableClearable
                        options={serviceShopData || []}
                        value={selectedServiceShop || null}
                        getOptionLabel={(option) => (option ? option.Dsc : '')}
                        getOptionSelected={(option, value) => option.ServiceShopId === value.ServiceShopId}
                        disabled={DisabledControl}
                        renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined" />}
                        onChange={(event, value) => {
                          changeEmployees(value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card >
                <CardContent >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        autoSelect
                        disableClearable
                        options={employeeData || []}
                        value={selectedEmployee || null}
                        getOptionSelected={(option, value) => option.EmployeeId === value.EmployeeId}
                        getOptionLabel={(option) => (option ? option.Dsc : '')}
                        renderInput={(params) => <TextField {...params} label={t('lblEmployee')} variant="outlined" />}
                        onChange={(event, value) => {
                          setSelectedEmployee(value);
                          setEmployeeId(value.EmployeeId);
                          GetEmployees(value.EmployeeId);
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Card className={classes.cards}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <CardHeader
                      style={{ textAlign: 'left' }}
                      title={t('lblEmployeeInformation')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CardHeader
                      style={{ textAlign: 'right' }}
                      title={employeeId ? 'Id: ' + employeeId : 'Id: ' + 0}
                    />
                  </Grid>
                </Grid>
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={11} lg={11}>
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        options={siriusUserTypeData || []}
                        value={formData?.UserType ? formData?.UserType : []}
                        disableCloseOnSelect

                        getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={formData?.UserType.includes(option)}
                            />
                            {option.Dsc}
                          </React.Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} variant="outlined" label={t('lblUserType')} placeholder={t('lblUserType')}
                            required
                            error={formData?.UserType.length > 0 ? false : Required}
                          />
                        )}
                        onChange={(event, value) => {
                          setFormdata({ ...formData, UserType: value })
                        }
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={1} lg={1}>
                      <Box p={1}>
                        <VisibilityOffIcon onClick={() => GetUserPassword()} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        autoComplete="no"
                        label={t('lblRole')}
                        id="Role"
                        variant="outlined"
                        value={employeeRoleData ? formData.RoleId ? formData.RoleId : employeeRoleData[0].Id : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            RoleId: event.target.value
                          })
                        }
                      >
                        {employeeRoleData ? employeeRoleData?.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        }) : ''}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('lblEmployeeCode')}
                        autoComplete="no"
                        value={formData.TechnicianCode ? formData.TechnicianCode : ''}
                        id="TechnicianCode"
                        disabled={true}
                        variant="outlined"
                      >
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={12} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        label={t('lblSicilNo')}
                        autoComplete="no"
                        value={formData.RegistrationNo ? formData.RegistrationNo : ''}
                        id="SicilNo"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            RegistrationNo: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="FirstName"
                        fullWidth
                        error={formData?.FirstName?.length > 0 ? false : Required}
                        required
                        value={formData?.FirstName ? formData?.FirstName : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            FirstName: event.target.value
                          })
                        }
                        label={t('lblFirstName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="MiddleName"
                        value={formData.MiddleName ? formData.MiddleName : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            MiddleName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblMiddleName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="LastName"
                        fullWidth
                        value={formData.LastName ? formData?.LastName : ''}
                        error={formData?.LastName?.length > 0 ? false : Required}
                        required
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            LastName: event.target.value
                          })
                        }
                        label={t('lblLastName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} lg={4}>
                      <TextField
                        size="small"
                        id="Mail"
                        fullWidth
                        autoComplete="no"
                        value={formData.Email ? formData.Email : ''}
                        helperText={emailError}
                        error={ValidControlColor}
                        onChange={event => validateEmail(event)}
                        label={t('lblMail')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblEducation')}
                        autoComplete="no"
                        value={formData.Education ? formData.Education : ''}
                        id="Education"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Education: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={'1'} value={'1'}>
                          {t('lblHighSchool')}
                        </MenuItem>
                        <MenuItem key={'2'} value={'2'}>
                          {t('lblLicence')}
                        </MenuItem>
                        <MenuItem key={'3'} value={'3'}>
                          {t('lblAssociateDegree')}
                        </MenuItem>
                        <MenuItem key={'4'} value={'2'}>
                          {t('lblOther')}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={4} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblTitle')}
                        autoComplete="no"
                        // error={formData.Title.length > 0 ? false : Required}
                        // required
                        value={formData.Title ? formData.Title : ''}
                        id="Title"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Title: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={'Ms'} value={'Ms'}>
                          {'Ms'}
                        </MenuItem>
                        <MenuItem key={'Mrs'} value={'Mrs'}>
                          {'Mrs'}
                        </MenuItem>
                        <MenuItem key={'Mr'} value={'Mr'}>
                          {'Mr'}
                        </MenuItem>
                        <MenuItem key={'Dr'} value={'Dr'}>
                          {'Dr'}
                        </MenuItem>
                        <MenuItem key={'Prof'} value={'Prof'}>
                          {'Prof'}
                        </MenuItem>
                        <MenuItem key={'Other'} value={'Other'}>
                          {'Other'}
                        </MenuItem>
                        <MenuItem key={'ServiceShop'} value={'ServiceShop'}>
                          {'ServiceShop'}
                        </MenuItem>
                        <MenuItem key={'Prefer not say'} value={'Prefer not say'}>
                          {'Prefer not say'}
                        </MenuItem>
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                          <KeyboardDatePicker
                            margin="normal"
                            color="primary"
                            inputVariant="outlined"
                            id="Birthday"
                            size="small"
                            label={t('lblBirthday')}
                            invalidDateMessage={t('hatali_tarih')}
                            format={'dd.MM.yyyy'}
                            fullWidth
                            variant="outlined"
                            onChange={e => handleBirthdayChange(e)}
                            disable={readonly}

                            value={formData.Birthday ? formData.Birthday : ''}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                          <KeyboardDatePicker
                            margin="normal"
                            color="primary"
                            inputVariant="outlined"
                            id="StartDate"
                            size="small"
                            label={t('lblStartDate')}
                            invalidDateMessage={t('hatali_tarih')}
                            format={'dd.MM.yyyy'}
                            fullWidth
                            variant="outlined"
                            value={formData.StartDate ? formData.StartDate : moment()}
                            onChange={e => handleStartDateChange(e)}
                            disable={readonly}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                          <KeyboardDatePicker
                            margin="normal"
                            color="primary"
                            inputVariant="outlined"
                            id="EndDate"
                            size="small"
                            label={t('lblEndDate')}
                            invalidDateMessage={t('hatali_tarih')}
                            format={'dd.MM.yyyy'}
                            fullWidth
                            variant="outlined"
                            value={formData.EndDate ? formData.EndDate : moment()}
                            onChange={e => handleEndDateChange(e)}
                            disable={readonly}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblMilitary')}
                        autoComplete="no"
                        value={formData.Military ? formData.Military : ''}
                        id="Military"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Military: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={'1'} value={'1'}>
                          {t('lblYes')}
                        </MenuItem>
                        <MenuItem key={'2'} value={'2'}>
                          {t('lblNo')}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblMaritalStatus')}
                        autoComplete="no"
                        value={formData.MaritalStatus ? formData.MaritalStatus : ''}
                        id="MaritalStatus"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            MaritalStatus: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={'1'} value={'1'}>
                          {t('lblSingle')}
                        </MenuItem>
                        <MenuItem key={'2'} value={'2'}>
                          {t('lblMarried')}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblBloodType')}
                        autoComplete="no"
                        id="BloodType"
                        value={formData.BloodType ? formData.BloodType : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            BloodType: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={'0-'} value={'0-'}>
                          {'0-'}
                        </MenuItem>
                        <MenuItem key={'0+'} value={'0+'}>
                          {'0+'}
                        </MenuItem>
                        <MenuItem key={'A-'} value={'A-'}>
                          {'A-'}
                        </MenuItem>
                        <MenuItem key={'A+'} value={'A+'}>
                          {'A+'}
                        </MenuItem>
                        <MenuItem key={'B-'} value={'B-'}>
                          {'B-'}
                        </MenuItem>
                        <MenuItem key={'B+'} value={'B+'}>
                          {'B+'}
                        </MenuItem>
                        <MenuItem key={'AB-'} value={'AB-'}>
                          {'AB-'}
                        </MenuItem>
                        <MenuItem key={'AB+'} value={'AB+'}>
                          {'AB+'}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblDrivingLicense')}
                        autoComplete="no"
                        value={formData.DrivingLicense ? formData.DrivingLicense : ''}
                        id="DrivingLicense"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            DrivingLicense: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={'1'} value={'1'}>
                          {t('lblYes')}
                        </MenuItem>
                        <MenuItem key={'2'} value={'2'}>
                          {t('lblNo')}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblReasonLeaving')}
                        autoComplete="no"
                        value={formData.ReasonLeaving ? formData.ReasonLeaving : 0}
                        id="ReasonLeaving"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ReasonLeaving: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        <MenuItem key={0} value={0}>
                          {t('lblActive')}
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          {t('lblResignation')}
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          {t('lblRetirement')}
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          {t('lblEndofDeal')}
                        </MenuItem>
                      </TextField>
                    </Grid>
                    {/* Telefon Bölümü */}

                    <Grid item xs={12} sm={1} lg={1}>
                      <Box p={1}>
                        <AddBoxIcon onClick={handleOnAdd} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblSelectType')}
                        id="paramPhonesType"
                        required
                        error={paramPhonesType > 0 ? false : Required}
                        onChange={event =>
                          setParamPhonesType(event.target.value)
                        }
                        value={paramPhonesType}
                        variant="outlined"
                      >
                        {PhoneTypes && PhoneTypes?.map((p) => (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Dsc}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={8}>
                      <PhoneInput
                        country={SessionUser.TenantCode}
                        enableSearch={true}
                        inputProps={{
                          name: 'phone',
                          required: true
                        }}
                        inputStyle={Required & formData?.Phones?.length === 0 ? { borderColor: '#e53935' } : { width: '100' }}
                        containerStyle={{ textAlign: 'left' }}
                        countryCodeEditable={false}
                        value={newtel}
                        onChange={handleOnChange}
                      />
                    </Grid>
                    <Grid container item xs={12} spacing={1}>
                      {formData?.Phones?.map((item, index) => (
                        <Grid container item xs={12} spacing={1} key={index}>
                          <Grid item xs={12} sm={1} lg={1}>
                            <Box p={1}>
                              <DeleteForeverOutlinedIcon
                                style={{ color: 'black' }}
                                onClick={event =>
                                  DeletePhoneItem(event, item.Phone)
                                }
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3} lg={3}>
                            <TextField
                              size="small"
                              fullWidth
                              value={item.Dsc}
                              disabled={true}
                              variant="outlined"
                            ></TextField>

                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <PhoneInput
                              // country={formData.LanguageCode}
                              value={item.Phone}
                              disabled={true}
                              inputStyle={{ width: '100%' }}
                              containerStyle={{ textAlign: 'left' }}
                            // onChange={phone => this.setState({ phone })}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                    {/* Telefon Bölümü */}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card className={classes.cards}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <CardHeader
                      style={{ textAlign: 'left' }}
                      title={t('lblEmployeeAdress')}
                    />
                  </Grid>
                </Grid>
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={6}>
                      <ReactFlagsSelect
                        size="small"
                        selected={
                          formData.Addresses
                            ? (formData.Addresses[AddressIndex]?.Country === '' ? selected : formData.Addresses[AddressIndex]?.Country)
                            : selected
                        }
                        value={formData.Country ? formData.Country : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Country: event.target.value
                          })
                        }
                        searchable
                        id="Country"
                        name="Country"
                        onSelect={code => SetCountry(code)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        value={
                          formData.ConsumerAddressTypeId
                            ? formData.ConsumerAddressTypeId
                            : ''
                        }
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ConsumerAddressTypeId: event.target.value
                          })
                        }
                        select
                        autoComplete="no"
                        id="ConsumerAddressTypeId"
                        label={t('lblAddressType')}
                        variant="outlined"
                      >
                        {AddressTypes.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>

                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="State"
                        fullWidth
                        value={formData.State ? formData.State : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            State: event.target.value
                          })
                        }
                        label={t('lblState')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="Region"
                        fullWidth
                        value={formData.Region ? formData.Region : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Region: event.target.value
                          })
                        }
                        label={t('lblRegion')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="City"
                        fullWidth
                        value={formData.City ? formData.City : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            City: event.target.value
                          })
                        }
                        label={t('lblCity')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="District"
                        fullWidth
                        value={formData.District ? formData.District : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            District: event.target.value
                          })
                        }
                        label={t('lblDistrict')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="Neighborhood"
                        fullWidth
                        value={formData.Neighborhood ? formData.Neighborhood : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Neighborhood: event.target.value
                          })
                        }
                        label={t('lblNeighborhood')}
                        variant="outlined"
                        autoComplete="no"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="Street"
                        fullWidth
                        value={formData.Street ? formData.Street : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Street: event.target.value
                          })
                        }
                        label={t('lblStreet')}
                        variant="outlined"
                        autoComplete="no"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="ReferralNumber"
                        fullWidth
                        value={formData.Apartment ? formData.Apartment : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Apartment: event.target.value
                          })
                        }
                        label={t('lblApartment')}
                        variant="outlined"
                        autoComplete="no"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="DoorNumber"
                        fullWidth
                        value={formData.DoorNr ? formData.DoorNr : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            DoorNr: event.target.value
                          })
                        }
                        label={t('lblDoorNumber')}
                        variant="outlined"
                        autoComplete="no"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="PostCode"
                        fullWidth
                        value={formData.PostCode ? formData.PostCode : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            PostCode: event.target.value
                          })
                        }
                        label={t('lblPostCode')}
                        variant="outlined"
                        autoComplete="no"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={12}>
                      <TextField
                        size="small"
                        multiline
                        rows={6}
                        fullWidth
                        value={formData.Address ? formData.Address : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Address: event.target.value
                          })
                        }
                        id="Address"
                        label={t('lblAddress')}
                        variant="outlined"
                        autoComplete="no"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {/* <Card >
        <Grid item xs={12} xs={12}>
          <CardHeader
            style={{ textAlign: 'left' }}
            title={t('lblLastUpdate')}
          />
        </Grid>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={4}>
              <TextField
                size="small"
                id="CreateEmployee"
                autoComplete="no"
                value={formData.CreateEmployee ? formData.CreateEmployee: ''}
                onChange={event =>
                  setFormdata({
                    ...formData,
                    CreateEmployee: event.target.value
                  })
                }
                fullWidth
                label={t('lblCreateEmployee')}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <TextField
                size="small"
                id="UpdateEmployee"
                autoComplete="no"
                value={formData.UpdateEmployee ? formData.UpdateEmployee: ''}
                onChange={event =>
                  setFormdata({
                    ...formData,
                    UpdateEmployee: event.target.value
                  })
                }
                fullWidth
                label={t('lblUpdateEmployee')}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDatePicker
                    color="primary"
                    inputVariant="outlined"
                    id="orderDate"
                    size="small"
                    invalidDateMessage={t('hatali_tarih')}
                    format="dd.MM.yyyy"
                    fullWidth
                    label={t('lblUpdateDate')}
                    variant="outlined"
                    value={formData.UpdateDate ? formData.UpdateDate : ''}
                    onChange={e => handleUpdateDateChange(e)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    disabled
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
          </Grid>
        </CardContent>
      </Card> */}
    </Container>
  );
}
export default TechnicianManagement
